import { Alert, Card, Col, Row } from "react-bootstrap";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import ReactFancyBox from "react-fancybox";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import { getCurrencyCode } from "../../../../../helpers/CommonHelper";
import parse from "html-react-parser";
import GalleryPictures from "../../../../UI/shared/gallery/GalleryPictures";
const Details = ({ item, detailsDispatch, loadItem, loading }) => {
  const getItems = () => {
    let items = [];
    if (item.allergens?.length) {
      items.push({
        text: "Allergens",
        value: item.allergens.join(", "),
        type: "text",
      });
    }
    if (item.ingredients) {
      items = [
        ...items,
        {
          text: "Ingredients",
          value: item.ingredients,
          type: "text",
        },
      ];
    }
      if (item.sortOrder) {
      items = [
        ...items,
        {
          text: "Sort Order",
          value: item.sortOrder,
          type: "number",
        },
      ];
    }
    if (item.nutritionalInfo) {
      items = [
        ...items,
        {
          text: "Nutritional Info",
          value: item.nutritionalInfo,
          type: "text",
        },
      ];
    }
    if (item.youtubeLink) {
      items = [
        ...items,
        { text: "Youtube Link", value: item.youtubeLink, type: "link" },
      ];
    }

    return items;
  };
  return (
    <>
      <Row>
        <Col>
          <Card className="item  mb-2">
            <Card.Header className="ps-1 pe-2 py-0">
              <Card.Title className="m-0 p-0 ">
                <div className="d-flex ImageSectionSpacing">
                  <div className="ms-1 me-2">
                    <div className=" position-relative  ">
                      <div className="fossilImage">
                        <ReactFancyBox
                          thumbnail={
                            process.env.REACT_APP_BACKEND_URL +
                            "public/" +
                            item.image
                          }
                          image={
                            process.env.REACT_APP_BACKEND_URL +
                            "public/" +
                            item.image
                          }
                          caption={`${item.title}`}
                        />
                      </div>
                      {(item.status === "0" || item.status === 0) && (
                        <i className="fas fa-ban position-absolute ms-1 mb-2 banned2"></i>
                      )}
                    </div>
                  </div>

                  <div className="d-flex flex-column ms-1 mt-1">
                    <span className="m-0 text-bold memberName text-red">
                      {item.title}
                    </span>
                  </div>

                  {item.salePrice && (
                    <div className="d-flex flex-column  ms-1">
                      <h4 className="my-0 me-0 ms-1 text-bold text-primaryCream">
                        {" "}
                        ({item.salePrice} {getCurrencyCode()})
                      </h4>
                    </div>
                  )}
                  {item.price && (
                    <div className="d-flex flex-column  ms-1">
                      <h4 className="my-0 me-0 ms-1 text-bold text-primaryCream">
                        {" "}
                        ({item.price} {getCurrencyCode()})
                      </h4>
                    </div>
                  )}
                </div>
              </Card.Title>

              <div className="card-tools">
                <div className=" text-right  mt-1 mt-xl-2 mt-lg-2 mt-md-2 pt-xl-1 pt-lg-1 pt-md-1 pt-0u">
                  <span className="badge badge-light me-1 text-dark">
                    Status :{" "}
                    <span className="text-secondary">
                      <ModuleDisplayBoolean
                        value={item.status}
                        trueValue="Enabled"
                        falseValue="Disabled"
                      />{" "}
                    </span>
                  </span>
                  {item.createdAt && (
                    <span className="badge badge-light me-1 text-dark">
                      Created Date :{" "}
                      <span className="text-secondary">
                        <ModuleDisplayDate value={item.createdAt} />{" "}
                      </span>
                    </span>
                  )}
                </div>
              </div>
            </Card.Header>

            <Card.Body className="px-2 pt-1 pb-0">
              <Row>
                <Col className="mt-1 mb-1 ">
                  <StatsListing items={getItems()} />
                  {item.description && (
                    <Alert className="alert-custom-3 d-flex mb-1  flex-column p-1 font-small">
                      <strong className="me-1 mt-1 text-custom-1">
                        Description:
                      </strong>
                      <div className=" d-flex align-items-center flex-wrap p-1 font-small">
                        <span
                          className="font-small text-normal text-custom-1 html"
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        ></span>
                      </div>
                    </Alert>
                  )}
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <GalleryPictures
            module="foods"
            parentId={item._id}
            detailsDispatch={detailsDispatch}
            showAddPictureButton={true}
          />
        </Col>
      </Row>
    </>
  );
};

export default Details;
